import React, { useState } from "react";
import { Star, X } from "@phosphor-icons/react";

export function RatingModal({ ride, onSubmit, onClose }) {
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try { await onSubmit(rating, comment); } finally { setBusy(false); }
  };

  return (
    <div className="absolute inset-0 z-[1300] bg-slate-900/60 flex items-center justify-center p-4" data-testid="rating-modal">
      <div className="bg-white rounded-3xl p-6 w-full max-w-sm fade-in text-center">
        <button onClick={onClose} className="ml-auto block w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center" data-testid="rating-close-btn"><X size={18} /></button>
        <h2 className="font-display text-2xl font-bold mb-1">¿Qué tal tu viaje?</h2>
        <p className="text-slate-500 text-sm mb-4">{ride?.driver_name ? `Califica a ${ride.driver_name}` : "Califica tu experiencia"}</p>
        <div className="flex justify-center gap-1 mb-4">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              onMouseEnter={() => setHover(n)}
              onMouseLeave={() => setHover(0)}
              onClick={() => setRating(n)}
              data-testid={`star-${n}`}
            >
              <Star size={40} weight={(hover || rating) >= n ? "fill" : "regular"} className={(hover || rating) >= n ? "text-amber-400" : "text-slate-300"} />
            </button>
          ))}
        </div>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="input-field w-full mb-4 resize-none"
          rows={3}
          placeholder="Comentario (opcional)"
          data-testid="rating-comment"
        />
        <button onClick={submit} disabled={busy} className="btn-primary w-full" data-testid="rating-submit-btn">
          {busy ? "Enviando..." : "Enviar calificación"}
        </button>
      </div>
    </div>
  );
}
